var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body"
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "dataSource": _vm.data
    },
    scopedSlots: _vm._u([{
      key: "filterDropdown",
      fn: function fn(_ref) {
        var setSelectedKeys = _ref.setSelectedKeys,
          selectedKeys = _ref.selectedKeys,
          confirm = _ref.confirm,
          clearFilters = _ref.clearFilters,
          column = _ref.column;
        return _c('div', {
          staticClass: "custom-filter-dropdown"
        }, [_c('a-input', {
          directives: [{
            name: "ant-ref",
            rawName: "v-ant-ref",
            value: function value(c) {
              return _vm.searchInput = c;
            },
            expression: "(c) => (searchInput = c)"
          }],
          staticStyle: {
            "width": "188px",
            "margin-bottom": "8px",
            "display": "block"
          },
          attrs: {
            "placeholder": "Search ".concat(column.dataIndex),
            "value": selectedKeys[0]
          },
          on: {
            "change": function change(e) {
              return setSelectedKeys(e.target.value ? [e.target.value] : []);
            },
            "pressEnter": function pressEnter() {
              return _vm.handleSearch(selectedKeys, confirm);
            }
          }
        }), _c('a-button', {
          staticStyle: {
            "width": "90px",
            "margin-right": "8px"
          },
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function click() {
              return _vm.handleSearch(selectedKeys, confirm);
            }
          }
        }, [_vm._v("Search")]), _c('a-button', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "size": "small"
          },
          on: {
            "click": function click() {
              return _vm.handleReset(clearFilters);
            }
          }
        }, [_vm._v("Reset")])], 1);
      }
    }, {
      key: "filterIcon",
      fn: function fn(filtered) {
        return _c('a-icon', {
          style: {
            color: filtered ? '#108ee9' : undefined
          },
          attrs: {
            "type": "search"
          }
        });
      }
    }, {
      key: "customer",
      fn: function fn(text) {
        return [_vm.searchText ? _c('span', [_vm._l(text.toString().split(new RegExp("(?<=".concat(_vm.searchText, ")|(?=").concat(_vm.searchText, ")"), 'i')), function (fragment, i) {
          return [fragment.toLowerCase() === _vm.searchText.toLowerCase() ? _c('mark', {
            key: i,
            staticClass: "highlight"
          }, [_vm._v(_vm._s(fragment))]) : [_vm._v(_vm._s(fragment))]];
        })], 2) : [_c('a', {
          staticClass: "btn btn-sm btn-light",
          attrs: {
            "href": "javascript: void(0);"
          }
        }, [_vm._v(_vm._s(text))])]];
      }
    }, {
      key: "progress",
      fn: function fn(bar) {
        return [_c('div', {
          staticClass: "progress"
        }, [_c('div', {
          class: ['progress-bar', bar.color],
          style: {
            width: bar.value + '%'
          },
          attrs: {
            "role": "progressbar"
          }
        })])];
      }
    }, {
      key: "value",
      fn: function fn(text) {
        return [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "id",
      fn: function fn(text) {
        return _c('a', {
          staticClass: "btn btn-sm btn-light",
          attrs: {
            "href": "javascript: void(0);"
          }
        }, [_vm._v(_vm._s(text))]);
      }
    }, {
      key: "total",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v("$" + _vm._s(text))]);
      }
    }, {
      key: "tax",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v("$" + _vm._s(text))]);
      }
    }, {
      key: "shipping",
      fn: function fn(text) {
        return _c('span', {}, [_vm._v("$" + _vm._s(text))]);
      }
    }, {
      key: "status",
      fn: function fn(text) {
        return _c('span', {
          class: [text === 'Processing' ? 'font-size-12 badge badge-primary' : 'font-size-12 badge badge-default']
        }, [_vm._v(_vm._s(text))]);
      }
    }])
  }, [_c('span', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-light mr-2",
    attrs: {
      "href": "javascript: void(0);"
    }
  }, [_c('i', {
    staticClass: "fe fe-edit mr-2"
  }), _vm._v(" View ")]), _c('a', {
    staticClass: "btn btn-sm btn-light",
    attrs: {
      "href": "javascript: void(0);"
    }
  }, [_c('small', [_c('i', {
    staticClass: "fe fe-trash mr-2"
  })]), _vm._v(" Remove ")])])])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-header card-header-flex"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-center"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript: void(0);"
    }
  }, [_vm._v("New Order")])])]);
}]

export { render, staticRenderFns }